import React from 'react';

import { ModalType } from '../types';

type PaddingType = '48_32_32' | '24_32' | '0';

const PADDING_CLASS: Record<PaddingType, string> = {
  // Alert, Confirm 사용
  '48_32_32': 'px-8 pb-8 pt-12',
  // 기본값
  '24_32': 'px-8 py-6',
  '0': 'p-0',
};

type Props = {
  size?: ModalType['size'];
  padding?: PaddingType;
  children: React.ReactNode;
};

export default function ModalBody({
  size,
  children,
  padding = '24_32',
}: Props) {
  // 원본은 size !== 'full' 일 때 overflow-y: auto 를 한 번 더 선언했는데
  // 기본 선언과 동일해 결과가 같다.
  void size;

  return (
    <div className="custom-scroll-default h-full overflow-y-auto text-sm font-medium">
      <div
        className={`flex flex-col justify-center gap-4 ${PADDING_CLASS[padding]}`}
      >
        {children}
      </div>
    </div>
  );
}
